import platform from "../../../util/platform";
const getAll = () => {
    return (params) => {
        const path = `/content/canvas/templates`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const canvasTemplates = {
    getAll,
};
export default canvasTemplates;
